import wixData from 'wix-data';

function todayInParis() {
  const nowParisStr = new Date().toLocaleString("fr-FR", { timeZone: "Europe/Paris" });
  const [datePart] = nowParisStr.split(" ");
  const [jour, mois, annee] = datePart.split("/");
  return new Date(`${annee}-${mois.padStart(2,"0")}-${jour.padStart(2,"0")}T00:00:00`);
}

function buildDefaultMessage(p) {
  const d = (dt) => dt.toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" });
  const dayAfterEnd = new Date(p.endDate.getTime() + 24*60*60*1000);
  return `🚚 Expéditions suspendues du ${d(p.startDate)} au ${d(p.endDate)}. Reprise le ${d(dayAfterEnd)}. Merci de votre compréhension 🙏`;
}

async function fetchActiveHoliday() {
  const today = todayInParis();
  const startOfToday = new Date(today);
  const endOfToday = new Date(today.getTime() + (24*60*60*1000 - 1));

  const res = await wixData.query("Vacations") // <= ID exact avec majuscule
    .eq("enabled", true)
    .le("startDate", endOfToday)
    .ge("endDate", startOfToday)
    .ascending("startDate")
    .find();

  if (res.items.length > 0) {
    const p = res.items[0];
    return {
      startDate: new Date(p.startDate),
      endDate: new Date(p.endDate),
      message: (p.message || "").trim()
    };
  }
  return null;
}

$w.onReady(async () => {
  try {
    const active = await fetchActiveHoliday();
    if (active) {
      const msg = active.message || buildDefaultMessage(active);
      $w('#vacationText').text = msg;
      $w('#vacationStrip').show();   // "Masqué" -> show()
    } else {
      $w('#vacationStrip').hide();
    }
  } catch (e) {
    $w('#vacationStrip').hide();
    console.error('Holiday banner (header) error:', e);
  }
});
